import React from 'react'
import Corporatebanner from './Corporatbanner'
import Features from './Features';
import Speakto from './Speakto';

const MainCorporate = () => {
  return (
    <>
      <Corporatebanner />
      <Features/>
      <Speakto/>
    </>
  );
}

export default MainCorporate